"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fluentProviderClassNames: function() {
        return fluentProviderClassNames;
    },
    useFluentProviderStyles_unstable: function() {
        return useFluentProviderStyles_unstable;
    }
});
const _core = require("@griffel/core");
const _react = require("@griffel/react");
const fluentProviderClassNames = {
    root: 'fui-FluentProvider'
};
const useStyles = /*#__PURE__*/ (0, _core.__styles)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const useFluentProviderStyles_unstable = (state)=>{
    'use no memo';
    const renderer = (0, _react.useRenderer_unstable)();
    const styles = useStyles({
        dir: state.dir,
        renderer
    });
    state.root.className = (0, _core.mergeClasses)(fluentProviderClassNames.root, state.themeClassName, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useFluentProviderStyles.styles.js.map
